import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { isTokenExpired } from '../utils/jwt';

export type User = { id: string; email: string; roles: string[]; preferredLanguage: string } | null;

export type AuthContextValue = {
  user: User;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (token: string, user: User) => void;
  logout: () => void;
};

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [token, setToken] = useState<string | null>(null);
  const [user, setUser] = useState<User>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log('AuthContext: Начинаю восстановление авторизации...');
    const t = localStorage.getItem('auth_token');
    const u = localStorage.getItem('auth_user');
    
    console.log('AuthContext: Токен из localStorage:', t ? 'есть' : 'нет');
    console.log('AuthContext: Пользователь из localStorage:', u ? 'есть' : 'нет');
    
    if (t && u) {
      // Проверяем, не истек ли срок действия токена
      if (isTokenExpired(t)) {
        console.log('AuthContext: Токен истек, очищаю localStorage');
        // Токен истек, очищаем localStorage
        localStorage.removeItem('auth_token');
        localStorage.removeItem('auth_user');
        setIsLoading(false);
        return;
      }
      
      console.log('AuthContext: Токен валиден, восстанавливаю авторизацию');
      setToken(t);
      setUser(JSON.parse(u));
    } else {
      console.log('AuthContext: Нет сохраненных данных авторизации');
    }
    
    setIsLoading(false);
    console.log('AuthContext: Восстановление завершено');
  }, []);

  const value = useMemo<AuthContextValue>(() => ({
    user,
    token,
    isAuthenticated: !!token,
    isLoading,
    login: (t: string, u: User) => {
      console.log('AuthContext: Сохраняю данные авторизации');
      setToken(t);
      localStorage.setItem('auth_token', t);
      setUser(u);
      localStorage.setItem('auth_user', JSON.stringify(u));
      console.log('AuthContext: Данные авторизации сохранены');
    },
    logout: () => {
      console.log('AuthContext: Выход из системы');
      setToken(null);
      setUser(null);
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      // Перенаправляем на страницу логина
      window.location.href = '/login';
    },
  }), [token, user, isLoading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
